<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('purchaseOrder.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('purchaseOrder.pageTitle'),
            href: '/admin/purchase-orders'
          },
          {
            text: $t('edit'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <form class="form-horizontal ts-space-y-3">
            <div class="row">
              <div class="col-md-12">
                <Info
                  v-model="model"
                  :validate="errors"
                  class="tw-p-3 tw-rounded"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <ItemList
                  v-model="model"
                  :validate="errors"
                  class="ts-border ts-rounded"
                />
              </div>
            </div>
            <div class="row">
              <div
                class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end"
              >
                <ts-button
                  @click.prevent="$router.push({ name: 'purchase-order' })"
                  >{{ $t('cancel') }}</ts-button
                >
                <ts-button
                  :waiting="waiting"
                  @click.prevent="onUpdate"
                  color="primary"
                  >{{ $t('update') }}</ts-button
                >
              </div>
            </div>
          </form>
          <a-modal
            :title="$t('pdf')"
            width="50%"
            v-model="show_pdf"
            :footer="null"
          >
            <ts-preview-pdf v-model="waiting" :src="src" />
          </a-modal>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import Info from './components/purchase-order-info.vue'
import ItemList from './components/item-list'

export default {
  name: 'purchaseOrderEdit',
  components: {
    Info,
    ItemList
  },
  data () {
    return {
      loading: false,
      waiting_new: false,
      waiting: false,
      show_pdf: false,
      src: '',
      errors: new Errors(),
      model: {
        po_date: moment().format('DD-MM-YYYY'),
        vendor_id: null,
        description: null,
        reference_no: null,
        purchase_type_id: null,
        fx_rate_khr: null,
        fx_rate_thb: null,
        credit_day: 0,
        po_detail: []
      }
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('purchaseOrder/order', ['edit_data']),
    supplierList () {
      return this.$store.state.purchaseOrder.order.suppliers.map(el => ({
        value: el.vendor_id,
        label: el.vendor_name
      }))
    }
  },
  methods: {
    ...mapActions('purchaseOrder/order', [
      'getSupplier',
      'getProduct',
      'getMeasure',
      'getPurchaseType',
      'getexFx',
      'update',
      'find'
    ]),
    async fetchData () {
      this.loading = true
      await this.getSupplier()
      await this.getProduct()
      await this.getMeasure()
      await this.getPurchaseType()
      await this.setExchangeRate()
      await this.find(this.$route.params.id)
      this.setEditData()
      this.loading = false
    },
    async setExchangeRate () {
      await this.getexFx()
      let fxRate = this.$store.state.purchaseOrder.order.exchangeRate.find(
        e => e.to_currency == 'KHR'
      )
      if (fxRate) {
        this.model.fx_rate_khr = parseFloat(fxRate.fx_rate)
      }
      let fxBath = this.$store.state.purchaseOrder.order.exchangeRate.find(
        e => e.to_currency == 'THB'
      )
      if (fxBath) {
        this.model.fx_rate_thb = parseFloat(fxBath.fx_rate)
      }
    },
    onUpdate () {
      this.waiting = true
      this.show_pdf = true
      this.errors = new Errors()
      this.update({
        id: this.$route.params.id,
        data: this.model
      })
        .then(response => {
          // this.$toasted.success(response.message)
          // this.$router.push({ name: 'purchase-order' })
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.show_pdf = false
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData () {
      this.model.po_date = this.edit_data.po_date
      this.model.vendor_id = this.edit_data.vendor_id
      this.model.description = this.edit_data.description
      this.model.reference_no = this.edit_data.reference_no
      this.model.po_detail = this.edit_data.details.map(el => ({
        product_id: el.product_id,
        uom_id: el.uom_id,
        qty: el.quantity_order,
        uom_cat_id: el.product.uom_cat_id,
        maximum_reorder_allow: el.product.maximum_reorder_allow
          ? el.product.maximum_reorder_allow
          : 0,
        alloworder:
          el.quantity_order >
          (el.product.maximum_reorder_allow
            ? el.product.maximum_reorder_allow
            : 0),
        cost: el.cost * this.edit_data.fx_rate_thb,
        cost_in_bath: el.cost,
        discount_rate: el.discount_rate,
        discount_type: el.discount_type,
        total_after_discount_in_bath: el.total_after_discount,
        total_after_discount: _.round(
          el.total_after_discount * this.edit_data.fx_rate_thb,
          2
        )
      }))

      this.model.fx_rate_khr = this.edit_data.fx_rate_khr
      this.model.fx_rate_thb = this.edit_data.fx_rate_thb
      this.model.purchase_type_id = this.edit_data.purchase_type_id
      this.model.credit_day = this.edit_data.credit_day
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('purchaseOrder/order/CLEAR_SETUP')
    this.$store.commit('purchaseOrder/order/SET_EDIT_DATA', [])
    next()
  }
}
</script>
